const button = "_61b1ii2sm4";

export { button };
import "./tool.course-builder.style.linaria.module.css";
//# sourceMappingURL=tool.course-builder.style.js.map
